/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineReference {
    getFixupPrototypeFunction() { return TagBaselineReference.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineReference>): TagBaselineReference {
        let obj = Object.assign(new TagBaselineReference(), model);
        TagBaselineReference.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineReference>): TagBaselineReference {
        if (!model) return null;
        return TagBaselineReference.newInstance(<TagBaselineReference> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineReference) {
        if (!obj) return;

        models.TagBaselineReference.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineReference): boolean {
        Object.setPrototypeOf(obj, TagBaselineReference.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    baseline_id: string;

    baseline_version_id: string;

}
